import * as React from 'react';
import styled from 'styled-components';
import { media } from '@packages/ui';

import { ModuleSocialEmbed } from '@packages/common';
import { initFacebook } from './FacebookEmbed.utils';

export const Container = styled.div`
  text-align: center;
  overflow: hidden;
  margin: 0 -8px;

  ${media.from.sm`
    margin: 0;
  `};
`;

export type FacebookEmbedProps = ModuleSocialEmbed;

export class FacebookEmbed extends React.PureComponent<FacebookEmbedProps> {
  containerRef = React.createRef<HTMLDivElement>();

  componentDidMount() {
    this.parse();
  }
  componentDidUpdate() {
    this.parse();
  }

  async parse() {
    const fb = await initFacebook();
    fb.XFBML.parse(this.containerRef.current);
  }

  public render(): React.ReactNode {
    const { embedCode } = this.props;
    return (
      <Container ref={this.containerRef}>
        <div className="fb-post" data-href={embedCode} />
      </Container>
    );
  }
}
